import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibEmptyCell() {
  return /*#__PURE__*/_jsx("td", {});
}